import { defineMessages } from 'react-intl';

export default defineMessages({
    searchForTopic: {
        id: 'faq.directive.Search for a topic',
        defaultMessage: 'Search for a topic',
    },
    generalBilling: {
        id: 'faq.sections.General Billing',
        defaultMessage: 'General Billing',
    },
    payAsYouGo: {
        id: 'faq.sections.Pay-As-You-Go',
        defaultMessage: 'Pay-As-You-Go',
    },
    claim: {
        id: 'faq.sections.Claim',
        defaultMessage: 'Claim',
    },
    customizeFAQContent: {
        id: 'faq.sections.How to customize the FAQ content',
        defaultMessage: 'How to customize the FAQ content',
    },
    frequentlyAskedQuestions: {
        id: 'faq.directive.Frequently Asked Questions',
        defaultMessage: 'Frequently Asked Questions',
    },
    paygWhatis: {
        id: 'faq.topics.payg_what_is.question',
        defaultMessage: 'What is Pay-As-You-Go?',
    },
    paygWhatisAnswer: {
        id: 'faq.topics.payg_what_is.answer.long',
        defaultMessage: 'It is a Payroll reporting plan linked directly with your payroll provider and based on your payroll frequency (weekly, bi-weekly, semi-monthly, or monthly). The premium is calculated, and payments are automatically withdrawn from your bank account. Credit card payments are not accepted for this program. <br/><br/>Our <b>Premier Payroll Connections</b> is an add-on to the Pay-As-You-Go package for an additional fee (see information below). This enhancement utilizes automated data feeds, which allow for real-time payroll reporting information, reducing the need for manual entry and minimizing the risk of errors. The result is more accurate workers’ compensation premiums, cost savings for your business, and reduced anxiety at audit. <br/><br/> (Businesses of all sizes are qualified to enroll in the Pay-As-You-Go billing option. It must be chosen at the time of policy issuance. No mid-term changes.)',
    },
    paygReadyToIntegrate: {
        id: 'faq.topics.payg_ready_to_integrate.question',
        defaultMessage: 'How do I know if my payroll provider is already integrated?',
    },
    paygReadyToIntegrateAnswer: {
        id: 'faq.topics.payg_ready_to_integrate.answer.long',
        defaultMessage: 'Please let your broker know the name of your payroll provider. Your broker will verify with us if they are already integrated. If they are not, we will reach out to them to determine if they are willing to partner with us to service your account. We will communicate with your payroll company to discuss the integration process and set up. If they are willing to integrate, they may charge you a processing fee. If they are not willing to integrate, you can self-administer, which requires you to report the payroll yourself through the dedicated Pay-As-You-Go portal.',
    },
    paygHowtoSignup: {
        id: 'faq.topics.payg_how_do.question',
        defaultMessage: 'How do I sign up?',
    },
    paygHowtoSignupAnswer: {
        id: 'faq.topics.payg_how_do.answer.long',
        defaultMessage: 'Please notify your broker prior to the renewal date of your interest in this option and provide them with the payroll company information. We will also require the name, email address, and phone number of the person from your company who will be responsible for the initial registration.',
    },
    paygHowitWorks: {
        id: 'faq.topics.payg_how_it_works.question',
        defaultMessage: 'How does it work?',
    },
    paygHowitWorksAnswer: {
        id: 'faq.topics.payg_how_it_works.answer.long',
        defaultMessage: 'You will receive an email to register when the policy is issued. Once registration is complete and payroll is processed by your payroll company or yourself, an email is sent with the computed premium balance and the date the funds will be withdrawn from your bank account. No waiting for invoices, no checks to mail; all information is accessible from the Pay-As-You-Go website.',
    },
    paygPremierConn: {
        id: 'faq.topics.payg_premier_conn.question',
        defaultMessage: 'Who are the Premier Payroll Connections?',
    },
    paygPremierConnAnswer: {
        id: 'faq.topics.payg_premier_conn.answer.long',
        defaultMessage: 'The major Premier Payroll Connections are Run Powered by ADP, Paychex, Gusto, Quickbooks Online, Paycom, and others. Please inquire with your broker as these companies are updated periodically. There is an annual integration fee of $240.',
    },
    paygPayrollConnVsProviders: {
        id: 'faq.topics.payg_payroll_providers.question',
        defaultMessage: 'What is the difference between Premier Payroll Connections and other payroll providers?',
    },
    paygPayrollConnVsProvidersAnswer: {
        id: 'faq.topics.payg_payroll_providers.answer.long',
        defaultMessage: 'The larger payroll providers restricted integration with outside carriers and have recently allowed payroll integration for workers’ comp purposes through a 3rd party for a nominal annual fee of $240. Consent is given and payment for the fee is made at the time of registration.',
    },
    paygVsTraditionalReporting: {
        id: 'faq.topics.payg_traditional_reporting.question',
        defaultMessage: 'What is the difference between Pay-As-You-Go and the traditional payroll reporting?',
    },
    paygVsTraditionalReportingAnswer: {
        id: 'faq.topics.payg_traditional_reporting.answer.long',
        defaultMessage: 'Traditional payroll reporting plans may require a down payment and are completely self-administered; payrolls are reported monthly (1st – 30th). You are required to complete the paper form or enter the data through Epayroll. Invoices are generated and mailed or emailed. Checks, credit cards, EFT, and AutoPay are an option for payment. ',
    },
    paygFee: {
        id: 'faq.topics.payg_republic_fee.question',
        defaultMessage: 'Does Republic charge a fee?',
    },
    paygFeeAnswer: {
        id: 'faq.topics.payg_republic_fee.answer.long',
        defaultMessage: 'Republic does not charge a fee.',
    },
    paygRateDiff: {
        id: 'faq.topics.payg_rate_diff.question',
        defaultMessage: 'Is there a rate difference if I choose Pay-As-You-Go?',
    },
    paygRateDiffAnswer: {
        id: 'faq.topics.payg_rate_diff.answer.long',
        defaultMessage: ' There is no difference in rate',
    },
    paygWhyTwoSites: {
        id: 'faq.topics.payg_why_two_sites.question',
        defaultMessage: 'Why are there two websites?',
    },
    paygWhyTwoSitesAnswer: {
        id: 'faq.topics.payg_why_two_sites.answer.long',
        defaultMessage: 'Republic has two websites: <br/><br/> Pay-As-You-Go (https://republicindemnity.payrollpl.us) : provides only payroll and billing details. <br/><br/>The general website (https://www.republicindemnity.com) provides claims, coverage information, billing, and payment information (for all other pay plans), and limited payment information on Pay-As-You-Go policyholders.',
    },
    differentWaysToPay: {
        id: 'faq.topics.payment_methods.question',
        defaultMessage: 'What are the different ways to pay for my insurance policy?',
    },
    creditCardPayment: {
        id: 'faq.topics.payment_methods.link.To make a one time credit card payment, please click here.',
        defaultMessage: 'To make a one time credit card payment, please click here.',
    },
    correctBillingMistake: {
        id: 'faq.topics.billing_mistake.question',
        defaultMessage: 'How can I correct a billing mistake made in the last three months?',
    },
    reportBillingMistake: {
        id: 'faq.topics.billing_mistake.link.To report a billing mistake on your last statement, please click here.',
        defaultMessage: 'To report a billing mistake on your last statement, please click here.',
    },
    claimProcess: {
        id: 'faq.topics.when_to_claim.question',
        defaultMessage: 'When is it best to begin the claim process after something happened to my house?',
    },
    renewlaCostInFuture: {
        id: 'faq.topics.claim_rate_increase.question',
        defaultMessage: 'In the event of a claim against the insurance policy, will my insurance costs increase at renewal or at any time in the future?',
    },
    deductible: {
        id: 'faq.topics.deductible_payment.question',
        defaultMessage: 'Under what circumstances would I have to pay a deductible when making a claim?',
    },
    FaqTopic: {
        id: 'faq.topics.show_video.question',
        defaultMessage: 'How to make a youtube video appear in the answer for a FAQ topic?',
    },
    clickableLink: {
        id: 'faq.topics.show_link.question',
        defaultMessage: 'How can I show a clickable link appear in the answer for a FAQ topic?',
    },
    customText: {
        id: 'faq.topics.show_link_text.question',
        defaultMessage: 'How can I show custom text that can be clicked to access a link in the answer for a FAQ topic?',
    },
    clickedText: {
        id: 'faq.topics.show_link_text.This text can be clicked.',
        defaultMessage: 'This text can be clicked.',
    },
    formattingQuestion: {
        id: 'faq.topics.formatting.question',
        defaultMessage: 'How can I customize the format of the question and answer elements for a given topic?',
    },
    bankTransfer: {
        id: 'faq.topics.payment_methods.answer.long',
        defaultMessage: 'Payments can be made using a major credit/debit card or a bank transfer.',
    },
    billngMistake: {
        id: 'faq.topics.billing_mistake.answer.long',
        defaultMessage: 'Billing mistakes should be brought to our attention as soon as they are found to ensure that they are promptly corrected. Please make sure to gather as much information about the mistake such as the date and amounts. You may then contact us through email, chat or phone.',
    },
    eventClaim: {
        id: 'faq.topics.when_to_claim.answer.long',
        defaultMessage: 'In order for us to best serve you in time of need, please notify us of any event that may lead to a claim as soon as you can reasonably expect to make a claim against your insurance policy.',
    },
    increasedRates: {
        id: 'faq.topics.claim_rate_increase.answer.long',
        defaultMessage: 'Filing a claim will not necessarily result in increased rates. Several factors are considered when rating a policy renewal.',
    },
    deductibleAmountasedRates: {
        id: 'faq.topics.deductible_payment.answer.long',
        defaultMessage: 'If the policy stipulates a deductible amount, the deductible amount must be covered when making a claim against the policy.',
    },
    navigateToVideo: {
        id: 'faq.topics.show_video.answer.long',
        defaultMessage: 'Using your browser, navigate to the youtube video that you would like to show. Copy the hash part of the url, for example in the following URL https://www.youtube.com/watch?v=XHB609to9dg the video hash is XHB609to9dg. Insert the video hash inside the topic object under a key named videoId.',
    },
    navigateToExternalLink: {
        id: 'faq.topics.show_link.answer.long',
        defaultMessage: 'Using your browser, navigate to the external link that you would like to show. Copy the url from the browser and insert into a new object as the value for the key url.',
    },
    navigateToExternalLinkText: {
        id: 'faq.topics.show_link_text.answer.long',
        defaultMessage: 'Using your browser, navigate to the external link that you would like to show. Copy the url from the browser and insert into a new object as the value for the key url.',
    },
    customFaq: {
        id: 'faq.topics.formatting.answer.long',
        defaultMessage: 'You can use html markup to customize the FAQ such as:&lt;h2&gt;A list example&lt;/h2&gt;&lt;ul&gt;&lt;li&gt;&lt;a href="http://example.com"&gt;The first item is a link&lt;/a&gt;&lt;/li&gt;&lt;li&gt;The second item is  &lt;strong&gt;an emphasis &lt;/strong&gt; &lt;/li&gt; &lt;li&gt;The third item is a spinner image  &lt;img src="throbber.gif" /&gt; &lt;/li&gt; &lt;li&gt;The fourth item is an escape of the tag &lt;div&gt; &lt;/li&gt; &lt;/ul&gt;',
    },
    typeQuestion: {
        id: 'faq.directive.Start typing your question...',
        defaultMessage: 'Start typing your question...',
    },
    sections: {
        id: 'faq.directive.Sections',
        defaultMessage: 'Sections',
    },
    noMatchingError: {
        id: 'faq.directive.No matching results found',
        defaultMessage: 'No matching results found',
    },
    aboutThePortal: {
        id: 'faq.sections.About the Portal',
        defaultMessage: 'About the Portal',
    },
    purposeOfClaimPortal: {
        id: 'faq.topics.about_portal_for_ph.inline_question',
        defaultMessage: 'What is the purpose of the Claim Portal for Policy Holders?',
    },
    purposeOfClaimPortalQuestion: {
        id: 'faq.topics.about_portal_for_ph.question',
        defaultMessage: 'What is the purpose of the Claim Portal for Policy Holders?',
    },
    purposeOfClaimPortalShortAnswer: {
        id: 'faq.topics.about_portal_for_ph.answer.short',
        defaultMessage: 'Claim Portal for Policyholders can be used to file a claim against a policy based on one or more lines of business',
    },
    purposeOfClaimPortalLongAnswer: {
        id: 'faq.topics.about_portal_for_ph.answer.long',
        defaultMessage: 'Claim Portal for Policyholders can be used to file a claim against a policy based on one or more lines of business.',
    },
    purposeOfClaimPortalProducer: {
        id: 'faq.topics.about_portal_for_producers.inline_question',
        defaultMessage: 'What is the purpose of the Claim Portal for Agents?',
    },
    purposeOfClaimPortalQuestionProducer: {
        id: 'faq.topics.about_portal_for_producers.question',
        defaultMessage: 'What is the purpose of the Claim Portal for Agents?',
    },
    purposeOfClaimPortalShortAnswerProducer: {
        id: 'faq.topics.about_portal_for_producers.answer.short',
        defaultMessage: 'The Claim Portal for Agents is intended for agents that can act on behalf of the insured.',
    },
    purposeOfClaimPortalLongAnswerProducer: {
        id: 'faq.topics.about_portal_for_producers.answer.long',
        defaultMessage: 'The Claim Portal for Agents is intended for agents that can act on behalf of the insured and perform actions like filing a new claim or verifying the status of an existing one.',
    }
});
